<template>
  <b-modal
    :id="`profile-edit-form-${detail_datas.id}`"
    content-class="rounded-xl"
    size="lg"
    hide-footer
    scrollable
    :title="`Update Data Profile: ${detail_datas.name || ''} - ${detail_datas.alias || ''}`"
    @show="resetModels"
  >
    <ValidationObserver v-slot="{ handleSubmit }" ref="baseForm">
        <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off">
            <b-row>
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.employee_photo"
                    :item="{
                        label: 'Foto Karyawan',
                        type: 'file',
                        attr: [{ accept: 'image/*, .pdf' }, { limit: 10 }],
                        validation: [],
                        placeholder: 'Masukan Disini',
                    }"
                    ></s-input>
                </b-col>
                <!-- Nama Alias -->
                <b-col cols="12" lg="6">
                    <s-input
                    v-model="mainData.alias"
                    :item="{
                        label: 'Nama Alias',
                        type: 'text',
                        validation: ['required'],
                        placeholder: 'Masukan disini ...',
                    }"
                    ></s-input>
                </b-col>
                <!-- Status Perkawinan -->
                <b-col cols="12" lg="6">
                    <s-input
                    v-model="mainData.marrital"
                    :item="{
                        label: 'Status Perkawinan',
                        type: 'select',
                        validation: ['required'],
                        placeholder: 'Pilih Status',
                        pointer: {
                        label: 'label',
                        code: 'code',
                        display: ['label'],
                        },
                        options: $_sys.staticOptions('marrital'),
                    }"
                    ></s-input>
                </b-col>
                <!-- Agama -->
                <b-col cols="12" lg="6">
                    <s-input
                    v-model="mainData.religion"
                    :item="{
                        label: 'Agama',
                        type: 'select',
                        validation: ['required'],
                        placeholder: 'Pilih Status',
                        pointer: {
                        label: 'label',
                        code: 'code',
                        display: ['label'],
                        },
                        options: $_sys.staticOptions('religion'),
                    }"
                    ></s-input>
                </b-col>
                <!-- Golongan Darah -->
                <b-col cols="12" lg="6">
                    <s-input
                    v-model="mainData.blood_type"
                    :item="{
                        label: 'Golongan Darah',
                        type: 'select',
                        validation: ['required'],
                        placeholder: 'Pilih Status',
                        pointer: {
                        label: 'label',
                        code: 'code',
                        display: ['label'],
                        },
                        options: $_sys.staticOptions('blood_type'),
                    }"
                    ></s-input>
                </b-col>
                <!-- Nomor KK -->
                <b-col cols="12" lg="6">
                    <s-input
                    v-model="mainData.kk_no"
                    :item="{
                        label: 'Nomor KK',
                        type: 'text',
                        validation: ['required', 'digits:16'],
                        placeholder: 'Masukan disini ...',
                    }"
                    ></s-input>
                </b-col>
                <!-- Nomor HP / Telfon -->
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.phone"
                    :item="{
                        label: 'Nomor HP / Telfon',
                        type: 'text',
                        validation: ['required'],
                        placeholder: 'Masukan Disini',
                    }"
                    ></s-input>
                </b-col>
                <!-- Nomor NPWP -->
                <b-col cols="12" lg="12">
                    <s-input
                    v-model="mainData.npwp"
                    :item="{
                        label: 'Nomor NPWP',
                        type: 'text',
                        validation: [],
                        placeholder: 'Masukan Disini',
                    }"
                    ></s-input>
                </b-col>
            </b-row>
            <b-row class="mx-0 animated">
            <b-btn variant="primary" class="mr-2" type="submit">
                <i class="ri-save-line"></i>
                Update Data Profile
            </b-btn>
            <b-btn
                @click="$bvModal.hide(`profile-edit-form-${detail_datas.id}`)"
                variant="light-primary"
            >
                Batal
            </b-btn>
            </b-row>
        </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
export default {
  name: "EditProfileForm",
  components: {
  },

  props: {
    isShowed: {
      type: Boolean,
      default: false,
    },
    detail_datas: {
      type: Object,
      required: true,
    },
  },

  computed: {
  },

  data() {
    return {
      isLoading: false,
      mainData: {
        // employee_photo: null,
        // alias: null,
        // marrital: null,
        // religion: null,
        // blood_type: null,
        // kk_no: null,
        // phone: null,
        // npwp: null
      }
    };
  },

  mounted() {
    const v = this.detail_datas;
    this.mainData = {
        ...this.mainData,
        ...v
      };
  },

  methods: {
    resetModels() { 
        const v = this.detail_datas;
        this.mainData = {
            ...this.mainData,
            ...v
        };
        // const v = this.detail_datas;
        // this.mainData = {
        //     employee_photo: null,
        //     alias: v.alias,
        //     marrital: v.marrital,
        //     religion: v.religion,
        //     blood_type: v.blood_type,
        //     kk_no: v.kk_no,
        //     phone: v.phone,
        //     npwp: v.npwp
        // };
    },
    onSubmit: async function () {
      const routeParam = this.$route.query; 
      try {
        const confirm = await this.$_alert.confirm(
          "Update Profile",
          "Pastikan Data Akun Anda Sesuai dengan Data Asli Anda!"
        );
        if (!confirm.isConfirmed) return;
        if(this.mainData){
            console.log('main data', this.mainData)
            this.$_api.put('employees/update', Object.assign({...this.mainData, update_type: 'profile'}, {id: this.detail_datas.id}));
        }
        } catch (err) {
          console.log("onSubmit() error", err);
          this.$_alert.error(err);
        } finally {
        this.$bvModal.hide(`profile-edit-form-${this.detail_datas.id}`);
        this.$emit("success");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/modules/profile/components/profile-edit-form.vue